import { render, staticRenderFns } from "./addfamily.vue?vue&type=template&id=79cfe406&"
import script from "./addfamily.vue?vue&type=script&lang=js&"
export * from "./addfamily.vue?vue&type=script&lang=js&"
import style0 from "./addfamily.vue?vue&type=style&index=0&id=79cfe406&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports